// helpers.js has a few functions that are reuseable throughout the project.  Kind of a storinghouse for functions.

import { TIMEOUT_SEC } from './config.js';

// this function will return a new promise which will reject after a certain amount of time

const timeout = function (s) {
  return new Promise(function (_, reject) {
    setTimeout(function () {
      reject(new Error(`Request took too long! Timeout after ${s} second`));
    }, s * 1000);
  });
};

// create a function that gets JSON.  This came from model.js.
// export const getJSON = async function (url) {
//   try {
//     const res = await Promise.race([fetch(url), timeout(TIMEOUT_SEC)]);
//     const data = await res.json();
//     if (!res.ok) throw new Error(`${data.message} (${res.status})`);
//     return data;
//   } catch (err) {
//     // what should we do with the error?  We want to handle it in the model, not here in the getJSON function.  So we use throw (throw the error).  Now, the promise that's returned from getJSON will propagate the error down to the model.
//     // now we need to set a timeout (or how much time we want to lapse before throwing the error)
//     throw err;
//   }
// };

export const AJAX = async function (url, uploadData = undefined) {
  try {
    const fetchPro = uploadData
      ? fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          // body has to be in JSON, so use JSON.stringify and convert the data.  uploadData is the second parameter
          body: JSON.stringify(uploadData),
        })
      : fetch(url);

    const response = await Promise.race([fetchPro, timeout(TIMEOUT_SEC)]);
    const data = await response.json();

    if (!response.ok) throw new Error(`${data.message} (${res.status})`);
    return data;
  } catch (err) {
    throw err;
  }
};
